import { useTable, useSortBy, usePagination } from 'react-table';
import './index.scss';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';
import { DownloadAllFileIconSVG } from 'src/Admin/img/uploadDocument/uploadDocumentSVG';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { axiosInstance } from 'src/api/axios';
import { toast } from 'react-toastify';
import ToastMessage from '../../common/ToastMessage';
import useDate from '../../../utils/useDate';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

const AdditionalPaymentTable = ({
  columns,
  data,
  dataFetching,
  paymentDetailsServerError,
  claimNumber,
}) => {
  console.log(data, 'data before display');
  const { formatDate } = useDate();
  //Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state: { sortBy },
  } = useTable(
    {
      columns,
      data,
      disableSortRemove: true,
      //initialState: { pageIndex: 0, pageSize: pageSizeCount, sortBy: [sortByColumn] },
      manualSortBy: true,
    },
    useSortBy,
    usePagination,
  );

  /*useEffect(() => {
    customSortingHandler(sortBy[0]?.id, sortBy[0]?.desc, sortBy);
  }, [sortBy]);*/

  /*const onClick = ele => {
    if ( ele ) {
      console.log( ele, 'PageRedirect' );
      navigate( `/admin/claim-details?trx=${ele}` );
    }
  };*/

  /*useMemo( () => {
    setPageSize( pageSizeCount );
  }, [ pageSizeCount ] );*/

  //Download EOP Handler
  const downloadEOP = async (claimNumber, value) => {
    try {
      const documentData = await axiosInstance.get(
        APIEndpoints.getEchoEOB() + claimNumber + '/DocType/' + value,
        { responseType: 'arraybuffer' },
      );
      if (documentData?.data?.byteLength < 10000 || documentData?.data === '') {
        toast.error(
          <ToastMessage
            type="error"
            title="Download Failed!"
            subTitle={
              'No EOP found for this Claim. Contact your Administrator for further information.'
            }
          />,
        );
      } else {
        const fileURL = window.URL.createObjectURL(
          new Blob([documentData.data]),
        );
        const downloadEOPLink = document.createElement('a');
        downloadEOPLink.href = fileURL;
        downloadEOPLink.download = `${'EOP'}-${claimNumber}.pdf`;
        document.body.appendChild(downloadEOPLink);
        downloadEOPLink.click();
        document.body.removeChild(downloadEOPLink);
      }
    } catch (error) {
      console.log(error);
      toast.error(
        <ToastMessage
          type="error"
          title="Download Failed!"
          subTitle={
            'No EOP found for this Claim. Contact your Administrator for further information.'
          }
        />,
      );
    }
  };

  //Render the UI for your table
  return (
    <div>
      <table className="table padding-mobile-0" {...getTableProps()}>
        {data?.length > 0 && (
          <thead>
            {headerGroups.map((headerGroup, index) => (
              <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th key={index} {...column.getHeaderProps()}>
                    <b>{column.render('Header')}</b>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
        )}

        <tbody {...getTableBodyProps()}>
          {page.map((row, index) => {
            prepareRow(row);
            return (
              <tr key={index} {...row.getRowProps()}>
                {row.cells.map((cell, index) => {
                  {
                    console.log('index', index);
                  }
                  return (
                    <td key={index} {...cell.getCellProps()}>
                      {index === 5 ? (
                        formatter.format(cell.value)
                      ) : index === 6 ? (
                        <div className="d-flex justify-content-center">
                          <span onClick={() => downloadEOP(claimNumber, 'CHK')}>
                            <DownloadAllFileIconSVG
                              parentClassName="cursor-pointer"
                              className="additioanl-payment-download-icon"
                            />
                          </span>
                        </div>
                      ) : index === 1 ? (
                        formatDate(cell.value)
                      ) : (
                        cell.render('Cell')
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {paymentDetailsServerError && !dataFetching && (
        <div className="claims-no-data text-center">
          <CustomClientError
            CustomClasses="p-0 m-0"
            ErrorHeading="Something went wrong with request!"
            ErrorMessage="Please try again."
          />
        </div>
      )}
    </div>
  );
};

export default AdditionalPaymentTable;
